<template>
  <div class="flex flex-col items-center justify-center">
    <img src="@/assets/images/conditional-order.svg" alt="conditional_order" />

    <NText weight="bold" class="py-3 text-neutral-secondary">
      {{ t('orders.conditional.whatIsConditionOfPrice') }}
    </NText>

    <div>
      <NText variant="caption1" weight="bold" class="block">
        {{ t('common.upperThan') }}:
      </NText>
      <NText variant="caption1">
        {{ t('orders.conditional.conditionalUpperThanPriceDescription') }}
      </NText>

      <NText variant="caption1" weight="bold" class="block">
        {{ t('common.lowerThan') }}:
      </NText>
      <NText variant="caption1">
        {{ t('orders.conditional.conditionalLowerThanPriceDescription') }}
      </NText>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
